"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _webcom = _interopRequireDefault(require("webcom/webcom"));

var _Browser = _interopRequireDefault(require("./definitions/Browser"));

var _StreamTypes = _interopRequireDefault(require("./definitions/StreamTypes"));

var Events = _interopRequireWildcard(require("./definitions/Events"));

var _Codec = require("./definitions/Codec");

var _User = _interopRequireDefault(require("./core/User"));

var _Room = _interopRequireDefault(require("./core/Room"));

var _Invite = _interopRequireDefault(require("./core/Invite"));

var DataSync = _interopRequireWildcard(require("./core/util/DataSync"));

var _cache = _interopRequireDefault(require("./core/util/cache"));

var Log = _interopRequireWildcard(require("./core/util/Log"));

var _Media = _interopRequireDefault(require("./core/util/Media"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Entry point for Reach SDK
 * @public
 */
var Reach =
/*#__PURE__*/
function () {
  /**
   * Create Reach's data structure where the url points to (might not be the root of your namespace)
   * @public
   * @param {string|Webcom} url The url of your namespace or an existing Webcom reference.
   * @param {Config} [cfg] Reach configuration. You can pass constraints here
   * @example <caption>Init with the default configuration</caption>
   * var myReach = new Reach('https://io.datasync.orange.com/base/<my_namespace>');
   * @example <caption>Init and set constraints for SD video and logLevel to 'info'</caption>
   * var myReach = new Reach('https://io.datasync.orange.com/base/<my_namespace>', {
   *  constraints: Reach.media.constraints('SD'),
   *  logLevel: 'INFO'
   * });
   */
  function Reach(url) {
    var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Reach);

    // Set shared reference
    _cache.default.base = url; // Set shared configuration

    _cache.default.config = cfg;
    /**
     * List of declared callbacks
     * @type {{}}
     * @private
     */

    this._callbacks = {};
  }
  /**
   * Get versions of SDK and DataModel.
   * The Schema version can be used to determine compatibility with the Android & iOS SDK.
   * @return {{sdk: string, schema: string}}
   */


  _createClass(Reach, [{
    key: "register",

    /**
     * Register & Sign-in as a new user
     * @param {string} email The email of the user
     * @param {string} password The password of the user
     * @param {string} [name] The display name of the user (defaults to email)
     * @param {boolean} [rememberMe=false] keep user connected ?
     * @returns {Promise<User>}
     */
    value: function register(email, password, name, rememberMe) {
      var _this = this;

      return _cache.default.base.createUser(email, password).then(function (auth) {
        if (auth) {
          return _this.login(email, password, name || email, rememberMe);
        }

        return null;
      }).catch(Log.r('Reach~register'));
    }
    /**
     * Sign-in an existing user
     * @param {string} email The email of the user
     * @param {string} password The password of the user
     * @param {string} [name] The name of the user. Defaults to the value in base.
     * @param {boolean} [rememberMe=false] keep user connected ?
     * @returns {Promise<User>}
     */

  }, {
    key: "login",
    value: function login(email, password, name) {
      var rememberMe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      // Force logout to bypass Webcom bug
      var p = Promise.resolve();

      if (this.current && this.current.email !== email) {
        p = this.logout();
      }

      return p.then(function () {
        return _cache.default.base.authWithPassword({
          email: email,
          password: password,
          rememberMe: rememberMe
        });
      }).then(function (auth) {
        return _User.default.init(auth, name);
      }).then(function (u) {
        _cache.default.user = u;
        return u;
      }).catch(Log.r('Reach~login'));
    }
    /**
     * Resume previous session
     * @returns {Promise<User>}
     */

  }, {
    key: "resume",
    value: function resume() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        // Resume session
        if (_webcom.default.INTERNAL.PersistentStorage.get('session')) {
          _cache.default.base.resume(function (error, auth) {
            if (auth && !_this2.current) {
              _User.default.init(auth).then(function (u) {
                _cache.default.user = u;
                resolve(u);
              }, reject);
            }
          });
        } else {
          reject(new Error('No session to resume'));
        }
      });
    }
    /**
     * Sign-in an anonymous user
     * @param {string} name The display name of the user
     * @returns {Promise<User>}
     */

  }, {
    key: "anonymous",
    value: function anonymous(name) {
      // Force logout to bypass Webcom bug
      var p = Promise.resolve();

      if (this.current && (!this.current.anonymous || this.current.name !== name)) {
        p = this.logout();
      }

      return p.then(function () {
        return _cache.default.base.authAnonymously();
      }).then(function (auth) {
        return _User.default.init(auth, name);
      }).then(function (u) {
        _cache.default.user = u;
        return u;
      }).catch(Log.r('Reach~anonymous'));
    }
    /**
     * Logout current user
     * @returns {Promise}
     */

  }, {
    key: "logout",
    value: function logout() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var p = Promise.resolve();

        if (_this3.current != null) {
          p = _User.default.disconnect(_this3.current);
        }

        p.then(function () {
          Object.keys(_this3._callbacks).forEach(function (event) {
            return DataSync.off(Events.reach.toPath(event)(_cache.default.user), event);
          });

          _cache.default.base.logout(function () {
            _cache.default.user = null;
            resolve();
          });
        }).catch(function (e) {
          Log.e(e);
          reject(e);
        });
      });
    }
    /**
     * Get the list of registered users
     * @ignore If your users base is pretty large, this method is impossible.
     * @param {boolean} [include=false] Include current user in user's list
     * @return {Promise<User[], Error>}
     */

  }, {
    key: "users",
    value: function users(include) {
      var _this4 = this;

      if (!this.current) {
        return Promise.reject(new Error('Only an authenticated user can list Users.'));
      }

      return DataSync.list('users', _User.default).then(function (users) {
        return !include && users && _this4.current ? users.filter(function (user) {
          return user.uid !== _this4.current.uid;
        }) : users;
      }).catch(Log.r('Reach~users'));
    }
    /**
     * Get the list of rooms
     * @ignore If your users base is pretty large, this method is impossible.
     * @return {Promise<Room[], Error>}
     */

  }, {
    key: "rooms",
    value: function rooms() {
      if (!this.current) {
        return Promise.reject(new Error('Only an authenticated user can list Rooms.'));
      }

      return DataSync.list('rooms', _Room.default).catch(Log.r('Reach~rooms'));
    }
    /**
     * Get the list of invites
     * @return {Promise<Invite[], Error>}
     */

  }, {
    key: "invites",
    value: function invites() {
      if (!this.current) {
        return Promise.reject(new Error('Cannot list invites without a User being logged in.'));
      }

      return DataSync.list("_/invites/".concat(this.current.uid), _Invite.default).catch(Log.r('Reach~invites'));
    }
    /**
     * Register a callback for a specific event
     * @param {string} event The event name ({@link Events/Reach}). Can be:
     * - USER_ADDED
     * - USER_CHANGED
     * - USER_REMOVED
     * - ROOM_ADDED
     * - ROOM_CHANGED
     * - ROOM_REMOVED
     * - INVITE_ADDED
     * - INVITE_CHANGED
     * @param {function} callback The callback for the event,
     * the arguments depends on the type of event:
     * - USER_*: callback({@link User} u)
     * - ROOM_*: callback({@link Room} r)
     * - INVITE_*: callback({@link Invite} i)
     * @param {Webcom/api.Query~cancelCallback} [cancelCallback] The error callback for the event,
     * takes an Error as only argument
     */

  }, {
    key: "on",
    value: function on(event, callback, cancelCallback) {
      var path = Events.reach.toPath(event)(_cache.default.user);

      if (path) {
        var Cls = Events.reach.toClass(event);

        var cb = function cb(snapData) {
          var d = Cls ? new Cls(snapData) : null;
          Log.i("Reach~on(".concat(event, ")"), d);
          callback(d);
        };

        DataSync.on(path, event, cb, cancelCallback);

        if (!this._callbacks[event]) {
          this._callbacks[event] = [];
        }

        this._callbacks[event].push(cb);
      }
    }
    /**
     * Create a new room
     * @param {string} [name] The room name
     * @param {object} [extra] Extra informations
     * @param {boolean} [publicRoom=false] Indicates public room
     * @returns {Promise<Room>}
     */

  }, {
    key: "createRoom",
    value: function createRoom(name, extra) {
      var publicRoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!this.current) {
        return Promise.reject(new Error('Cannot create a Room without a User being logged in.'));
      }

      return _Room.default.create(name, extra, publicRoom);
    }
    /**
     * Get a list of all opened {@link PeerConnection}s
     * @return {*}
     */

  }, {
    key: "getRoom",

    /**
     * Get a {@link Room} from its `uid`
     * @param {string} uid The room's UID
     * @returns {Promise.<Room>}
     */
    value: function getRoom(uid) {
      return _Room.default.get(uid);
    }
    /**
     * Get a {@link User} from its `uid`
     * @param {string} uid The user's UID
     * @returns {Promise.<User>}
     */

  }, {
    key: "getUser",
    value: function getUser(uid) {
      return _User.default.get(uid);
    }
  }, {
    key: "base",

    /**
     * DataSync reference
     * @type {Webcom}
     */
    get: function get() {
      return _cache.default.base;
    }
    /**
     * The configuration
     * @type {Config}
     */

  }, {
    key: "config",
    get: function get() {
      return _cache.default.config;
    }
    /**
     * The connected User
     * @type {User}
     */

  }, {
    key: "current",
    get: function get() {
      return _cache.default.user;
    }
  }, {
    key: "peerConnections",
    get: function get() {
      return _cache.default.peerConnections.stacks;
    }
  }], [{
    key: "version",
    get: function get() {
      return {
        sdk: SDK_VERSION,
        schema: SCHEMA_VERSION
      }; // eslint-disable-line no-undef
    }
    /**
     * The supported stream types
     * @returns {StreamTypes}
     */

  }, {
    key: "types",
    get: function get() {
      return _StreamTypes.default;
    }
    /**
     * The supported events
     * @return {{
        room: Events/Room,
        reach: Events/Reach,
        stream: Events/Stream,
        invite: Events/Invite,
        local: Events/Local
       }}
     */

  }, {
    key: "events",
    get: function get() {
      return {
        room: Events.room,
        reach: Events.reach,
        stream: Events.stream,
        invite: Events.invite,
        local: Events.local
      };
    }
    /**
     * The browser's details
     * @return {Browser}
     */

  }, {
    key: "browser",
    get: function get() {
      return _Browser.default;
    }
    /**
     * Media utility functions
     * @return {Media}
     */

  }, {
    key: "media",
    get: function get() {
      return _Media.default;
    }
    /**
     * The codec presets to use when setting {@link Config#preferredAudioCodec}
     * or {@link Config#preferredVideoCodec}
     * @return {{audio: Codec/audio, video: Codec/video}}
     */

  }, {
    key: "codecs",
    get: function get() {
      return {
        audio: _Codec.audio,
        video: _Codec.video
      };
    }
  }]);

  return Reach;
}();

exports.default = Reach;
module.exports = Reach;